// Module
var code = "<template> <div id=\"app-badge\" class=\"app-${env.config.instanceType || 'prod'}\" if.bind=\"env.config.instanceCode && env.config.showEnvironment\"> <div class=\"app-badge-instance\">${env.config.instanceCode}</div> <div class=\"app-badge-version\">${version.number}</div> </div> </template> ";
// Exports
module.exports = code;